<template>
  <p class="article-description text-gray-700 text-[1rem] leading-[1.5] pb-[1rem]">
    {{ truncatedText }}
  </p>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import type { ExcerptProps } from '~~/shared/types/common';

const props = withDefaults(defineProps<ExcerptProps>(), {
  maxLength: 200
})

const fullText = computed(() => props.description ?? '')

const shouldTruncate = computed(() => fullText.value.length > props.maxLength!)

const truncatedText = computed(() => {
  const max = props.maxLength!
  return shouldTruncate.value ? fullText.value.slice(0, max) + '...' : fullText.value
})
</script>
